module.exports = __webpack_public_path__ + "img/cpany16.0251f4a0.png";